import React from "react";
import DebouncedInput from "components/DebounceInput";
import { IconSearch, IconX } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import { epdSearchStore } from "features/EPDSearchModal/EPDSearchStore";

export default observer(function SearchInput(props: {
  open: boolean;
  onChange: (value: string | number) => void;
  value: string;
}) {
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    props.open &&
      !epdSearchStore.fetchingEPDsLoading &&
      inputRef.current?.focus();
  }, [props.open, epdSearchStore.fetchingEPDsLoading]);

  const handleKeyPressed = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.ctrlKey || e.metaKey) && e.code === "KeyA") {
      e.preventDefault();
      inputRef.current?.select();
    }
  };

  return (
    <DebouncedInput
      ref={inputRef}
      containerClassName="w-full mr-2 md:min-w-[200px]"
      onChange={props.onChange}
      value={props.value}
      iconClassName={props.value ? "!pointer-events-auto" : ""}
      icon={
        props.value ? (
          <IconX
            className="cursor-pointer"
            onClick={() => props.onChange("")}
          />
        ) : (
          <IconSearch />
        )
      }
      onKeyDown={handleKeyPressed}
    />
  );
});
